import React, {useEffect, useMemo, useState} from 'react';
import {Modal, Spin, Transfer, Typography} from 'antd';
import {getMenus} from '../api/menuApi';
import {updateMenuGroupMembers} from '../api/groupApi';

const { Text } = Typography;

/**
 * 메뉴 그룹 멤버 편집 모달
 * props:
 *  - open
 *  - group (MENU 타입 그룹 또는 null)
 *  - onCancel
 *  - onSuccess (after save)
 */
const GroupMenuMembersModal = ({ open, group, onCancel, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [allMenus, setAllMenus] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      setLoading(true);
      try {
        const res = await getMenus();
        const list = Array.isArray(res.data) ? res.data : [];
        setAllMenus(list);
      } catch (e) {
        // 에러 토스트는 공통 인터셉터에서 처리
      } finally { setLoading(false); }
    };
    load();
  }, [open]);

  useEffect(() => {
    if (group && open) {
      setTargetKeys((group.trgtIdList || []).map(id => id));
    } else if (!open) {
      setTargetKeys([]);
    }
  }, [group, open]);

  const dataSource = useMemo(() => {
    return (allMenus || []).map(m => ({
      key: m.menuId,
      title: m.menuNm || '(이름없음)',
      description: m.path || ''
    }));
  }, [allMenus]);

  const handleOk = async () => {
    if (!group) return;
    try {
      await updateMenuGroupMembers(group.groupId, targetKeys);
      onSuccess?.();
    } catch (e) {
      // 에러 토스트는 공통 인터셉터에서 처리
    }
  };

  return (
    <Modal
      open={open}
      title={group ? `메뉴 멤버 편집 - ${group.groupNm}` : '메뉴 멤버 편집'}
      onCancel={onCancel}
      onOk={handleOk}
      okButtonProps={{ disabled: !group }}
      okText="저장"
      cancelText="취소"
      width={760}
      destroyOnClose
    >
      {!group && <Text type="secondary">MENU 타입 그룹을 먼저 선택하세요.</Text>}
      {group && (
        loading ? <div style={{textAlign:'center',padding:40}}><Spin /></div> : (
          <Transfer
            dataSource={dataSource}
            titles={['전체 메뉴', '그룹 메뉴']}
            targetKeys={targetKeys}
            onChange={setTargetKeys}
            listStyle={{ width: 320, height: 360 }}
            showSearch
            filterOption={(inputValue, item) => (item.title || '').toLowerCase().includes(inputValue.toLowerCase()) || (item.description || '').toLowerCase().includes(inputValue.toLowerCase())}
            locale={{ itemUnit:'개', itemsUnit:'개', searchPlaceholder:'검색', notFoundContent:'없음' }}
            render={item => `${item.title}${item.description ? ' ('+item.description+')':''}`}
          />
        )
      )}
    </Modal>
  );
};

export default GroupMenuMembersModal;
